import { FleetTruckPage } from '@numeo/types-main-web-app'
import { requestApi } from './axiosBaseQuery'
import { baseApi } from './baseApi'

/**
 * The fleet's trucks (`/fleet/trucks/v1`) a page at a time, read from wherever the server keeps them. Every argument carries
 * the company's `applicationId`, so a cache entry never crosses companies. Read through `hooks/fleet/useFleetTrucks`.
 */

export interface FleetTrucksQuery {
    page?: number
    /** At most 100 (`FLEET_TRUCK_PAGE_LIMIT`). */
    limit?: number
    /** 2 to 64 characters: name, unit or VIN, across the whole fleet. */
    search?: string
    /** Exactly these trucks (at most 100). */
    ids?: readonly string[]
}

type ListFleetTrucksArg = FleetTrucksQuery & { applicationId: string }

/** The tag every page carries, so one truck save re-reads every page and search. */
export const FLEET_TRUCKS_LIST_ID = 'LIST'

const fleetTrucksApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        listFleetTrucks: build.query<FleetTruckPage, ListFleetTrucksArg>({
            queryFn: async (query, { signal }) => {
                // `applicationId` keys the cache only: the server answers for the token's company.
                const params = { page: query.page, limit: query.limit, search: query.search, ids: query.ids?.length ? query.ids.join(',') : undefined }
                const result = await requestApi<FleetTruckPage>({ url: '/fleet/trucks/v1', params }, signal)
                return 'error' in result
                    ? result
                    : { data: result.data ?? { items: [], pagination: { total: 0, page: query.page ?? 1, limit: query.limit ?? 0 } } }
            },
            providesTags: [{ type: 'Trucks', id: FLEET_TRUCKS_LIST_ID }],
        }),
    }),
})

export const { useListFleetTrucksQuery } = fleetTrucksApi
